import React, { Component } from 'react'

import Grid from 'components/Grid'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { configuring, confirmingDeletion, creating, renaming } from '../subs'
import ConfirmDelete from './confirm/Delete'
import Configure from './form/configuration/Dialog'
import Create from './form/name/Create'
import Rename from './form/name/Rename'
import Table from './Table'
import Toolbar from './toolbar/Toolbar'

class Tab extends Component {
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    companyKey: PropTypes.string.isRequired
  }

  render() {
    let form

    if (this.props.creating) {
      form = <Create companyKey={this.props.companyKey} />
    } else if (this.props.renaming) {
      form = <Rename companyKey={this.props.companyKey} />
    } else if (this.props.configuring) {
      form = <Configure companyKey={this.props.companyKey} />
    } else if (this.props.confirmingDeletion) {
      form = <ConfirmDelete companyKey={this.props.companyKey} />
    }

    return (
      <Grid className='mail-targets-grid'>
        <Toolbar store={this.props.store} companyKey={this.props.companyKey} />
        <Table
          width={this.props.width}
          height={this.props.height}
          store={this.props.store}
          companyKey={this.props.companyKey}
        />
        {form}
      </Grid>
    )
  }
}

const mapDbToProps = (db, props) => ({
  creating: creating(db, props.companyKey),
  configuring: configuring(db, props.companyKey),
  renaming: renaming(db, props.companyKey),
  confirmingDeletion: confirmingDeletion(db, props.companyKey)
})

export default connect(mapDbToProps)(Tab)
